import { useSelector } from "react-redux";
import JsBarcode from "jsbarcode";
import { useEffect } from "react";

export const styleBangKeChiPhi = `
#pdf-bkcp * { 
  font-size: 10pt; 
  line-height: 1.5;
  font-family: "Times New Roman", Times, serif;
  vertical-align: middle; 
}

#pdf-bkcp .input-box {
  width: 25px;
  height: 25px;
  border: 1px solid black;
  margin-left: -1px;
}
#pdf-bkcp .tick-box-wrapper {
  display: flex;
  text-align: center;
  gap: 8px;
  margin: 12px 0;
}
#pdf-bkcp .tick-box {
  width: 9px;
  height: 9px;
  border: 1px solid black;
  margin-top: 3px;
}

#pdf-bkcp .signature-box {
  border: 1px solid black;
  font-weight: bold;
  padding: 7px;
  width: 160px;
  text-align: center;
}
#pdf-bkcp .stamp-container {
  display: flex;
  gap: 5px;
  width: 390px;
  flex-wrap: wrap;
}
#pdf-bkcp .stamp-box {
  border: 1px solid black;
  padding: 8px;
  width: 170px;
  text-align: center;
  height: 80px;
}
#pdf-bkcp .small-num {
  font-size: 8pt;
  vertical-align: text-top;
}

#pdf-bkcp .header {
  display: flex;
  justify-content: space-between;
}

#pdf-bkcp .header b {
  display: block;
}

#pdf-bkcp h1 {
  font-size: 12pt;
  text-transform: uppercase;
  text-align: center;
  margin-top: -10px;
  margin-bottom: 0;
}

#pdf-bkcp h3 {
  margin-top: 10px;
  margin-bottom: 2px;
}

#pdf-bkcp .flex {
  display: flex;
  align-items: center;
}
#pdf-bkcp .w-6 {
  width: 60%;
}
#pdf-bkcp .w-5 {
  width: 50%;
}
#pdf-bkcp .w-4 {
  width: 40%;
}
#pdf-bkcp .w-3 {
  width: 30%;
}
#pdf-bkcp .w-2 {
  width: 20%;
}
#pdf-bkcp .w-1 {
  width: 10%;
}
#pdf-bkcp .gap-40 {
  gap: 40px;
}

#pdf-bkcp .table {
  border: 1px solid black;
  border-collapse: collapse;
  width: 100%;
  margin: 5px 0;
}
#pdf-bkcp .table th, .table td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 9px;
}

#pdf-bkcp .footer {
  margin-top: 40px;
  padding: 0 150px;
}
#pdf-bkcp .footer .flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  gap: 100px;
}
#pdf-bkcp .footer b {
  font-size: 11pt;
}
#pdf-bkcp .footer b, .footer i {
  display: block;
}

@media print {
  #pdf-bkcp * { break-inside: auto; }
}
`;

const BangKeChiPhi = ({ data, rid }) => {

  const { partner_code, benh_vien } = useSelector((state) => state.auth.user);

  const SO_PHIEU = "252405503";

  useEffect(() => {
    if (!!rid && !!SO_PHIEU) {
      JsBarcode(`#barcode-${rid}`)
        .options({ font: "OCR-B" })
        .CODE128(SO_PHIEU, {
          text: ` `,
          fontSize: 10,
          width: 1.2,
          height: 40,
          textMargin: 0,
          padding: 0,
        })
        .render();
    }
  }, [SO_PHIEU, rid]);


  return (
    <div id="pdf-bkcp">

      <section className="header">
        <div>
          <b>Bộ Y tế/ Sở Y Tế/ Y tế ngành: Sở Y tế Hà Nội</b>
          <b>PHÒNG KHÁM DEEPCARE</b>
          <b>Khoa: Tim mạch</b>
          <b>Mã khoa: K06</b>
        </div>
        <div>
          <div>Mẫu số: 01/KBCB</div>
          <div>Mã số người bệnh: 12001301923</div>
          <div>Số khám bệnh: 129391232</div>
          <svg id={`barcode-${rid}`} />
        </div>
      </section>

      <h1>BẢNG KÊ CHI PHÍ KHÁM BỆNH TỔNG HỢP</h1>

      <section className="body">

        <h3>I. Phần Hành chính</h3>
        <div className="flex">
          <div className="w-5">
            (1) Họ tên người bệnh:
          </div>
          <div className="w-3">
            Ngày, tháng, năm sinh:
          </div>
          <div className="w-2">
            Giới tính:
          </div>
        </div>
        <div className="flex">
          <div className="w-5">
            (2) Đại chỉ hiện tại:
          </div>
          <div className="w-5">
            (3) Mã khu vực (K1/K2/K3):
          </div>
        </div>
        <div className="flex">
          <div className="w-5">
            (4) Mã thẻ BHYT:
          </div>
          <div className="w-5">
            Giá trị từ 1/1/2025 đến 31/12/2025
          </div>
        </div>
        <div className="flex">
          <div className="w-5">
            (5) Nơi ĐK KCB ban đầu:
          </div>
          <div className="w-5">
            (6) Mã:
          </div>
        </div>
        <div>
          (7) Đến khám: 8 giờ 10 phút, ngày 28/03/2025
        </div>
        <div>
          (8) Điều trị ngoại trú/nội trú từ:
        </div>
        <div className="flex">
          <div className="w-3">
            (9) Kết thúc khám/điều trị:
          </div>
          <div className="w-3">
            Tổng số ngày điều trị:
          </div>
          <div className="w-4">
            (10) Tình trạng ra viện:
          </div>
        </div>
        <div className="flex">
          <div className="w-1">
            (11) Cấp cứu
          </div>
          <div className="w-1">
            (12) Đúng tuyến
          </div>
          <div className="w-3">
            Nơi chuyển đến từ
          </div>
          <div className="w-3">
            Nơi chuyển đi
          </div>
          <div className="w-1">
            (13) Thông tuyến
          </div>
        </div>
        <div>
          (14) Trái tuyến
        </div>
        <div className="flex">
          <div className="w-5">
            (15) Chẩn đoán xác định:
          </div>
          <div className="w-5">
            (16) Mã bệnh
          </div>
        </div>
        <div className="flex">
          <div className="w-5">
            (17) Bệnh kèm theo:
          </div>
          <div className="w-5">
            (18) Mã bệnh kèm theo
          </div>
        </div>
        <div className="flex">
          <div className="w-5">
            (19) Thời điểm đủ 05 năm liên tục từ ngày
          </div>
          <div className="w-5">
            (20) Miễn đồng chi trả trong năm từ ngày
          </div>
        </div>

        <h3>
          II. Chi phí khám bệnh, chữa bệnh:&nbsp;
          <span style={{ fontWeight: 400 }}>(Mỗi mã thẻ BHYT thống kê phần chi phí khám bệnh, chữa bệnh phát sinh tương ứng theo mã thẻ đó)</span>
        </h3>
        <div className="flex">
          <div className="w-5">
            Mã thẻ BHYT:
          </div>
          <div className="w-3">
            Giá trị từ 1/1/2025 đến 31/12/2025
          </div>
          <div className="w-2">
            Mức hưởng
          </div>
        </div>
        <div>
          (Chi phí KBCB tính từ ngày             đến ngày              )
        </div>

        <table className="table">
          <thead>
            <tr>
              <th rowSpan={2}>Nội dung</th>
              <th rowSpan={2}>Đơn vị tính</th>
              <th rowSpan={2}>Số lượng</th>
              <th rowSpan={2}>Đơn giá BV (đồng)</th>
              <th rowSpan={2}>Đơn giá BH (đồng)</th>
              <th rowSpan={2}>Tỷ lệ thanh toán theo dịch vụ (%)</th>
              <th rowSpan={2}>Thành tiền BV (đồng)</th>
              <th rowSpan={2}>Tỷ lệ thanh toán BHYT (%)</th>
              <th rowSpan={2}>Thành tiền BH (đồng)</th>
              <th colSpan={4}>Nguồn thanh toán (đồng)</th>
              <th rowSpan={2}>Đã thanh toán</th>
            </tr>
            <tr>
              <th>Quỹ BHYT</th>
              <th>Người bệnh cùng chi trả</th>
              <th>Nguồn khác</th>
              <th>Người bệnh tự trả</th>
            </tr>
            <tr>
              <th>(1)</th>
              <th>(2)</th>
              <th>(3)</th>
              <th>(4)</th>
              <th>(5)</th>
              <th>(6)</th>
              <th>(7)</th>
              <th>(8)</th>
              <th>(9)</th>
              <th>(10)</th>
              <th>(11)</th>
              <th>(12)</th>
              <th>(13)</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Khám nội</td>
              <td>Lần</td>
              <td>1</td>
              <td>100000</td>
              <td>100000</td>
              <td>100</td>
              <td>100000</td>
              <td>100</td>
              <td>100000</td>
              <td>100</td>
              <td>100000</td>
              <td>100</td>
              <td>100000</td>
              <td>x</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>Cộng:</td>
              <td colSpan={5} />
              <td>100000</td>
              <td />
              <td>100000</td>
              <td>100000</td>
              <td>100000</td>
              <td>100000</td>
              <td>100000</td>
              <td />
            </tr>
          </tfoot>
        </table>

        <div>
          Tổng chi phí lần khám bệnh/cả đợt điều trị (làm tròn đến đơn vị đồng):
        </div>
        <div>
          (Viết bằng chữ: Một trăm nghìn đồng)
        </div>
        <div>
          <b>Trong đó,</b> <span>số tiền do:</span>
        </div>
        <div className="flex">
          <div className="w-5 flex gap-40">
            <div>
              <div>- Quỹ BHYT thanh toán:</div>
              <div>- Người bệnh trả, trong đó:</div>
              <div> + Cùng trả trong phạm vi BHYT:</div>
              <div> + Các khoản phải trả khác:</div>
              <div>- Nguồn khác:</div>
            </div>
            <div>
              <div>100000</div>
              <div>100000</div>
              <div>100000</div>
              <div>100000</div>
              <div>100000</div>
            </div>
          </div>
          <div className="w-5 flex gap-40">
            <div>
              <div>- Tạm ứng:</div>
              <div>- Số tiền miễn giảm:</div>
              <div>- Số tiền cần thu thêm:</div>
              <div>- Số tiền đã thanh toán:</div>
              <div>- Số tiền cần trả lại:</div>
            </div>
            <div>
              <div>100000</div>
              <div>100000</div>
              <div>100000</div>
              <div>100000</div>
              <div>100000</div>
            </div>
          </div>
        </div>

      </section>

      <section className="footer">
        <div className="flex-between">
          <div>
            <div>
              <div>&nbsp;</div>
              <b>NGƯỜI LẬP BẢNG KÊ</b>
              <i>(ký, ghi rõ họ tên)</i>
            </div>
            <div style={{ height: 70 }} />
            <div>
              <div>&nbsp;</div>
              <b>XÁC NHẬN CỦA NGƯỜI BỆNH</b>
              <i>(ký, ghi rõ họ tên)</i>
              <i>Tôi đã nhận........phim.............</i>
            </div>
          </div>
          <div>
            <div>
              <div>
                <div>Ngày......tháng.....năm.....</div>
                <b>KẾ TOÁN VIỆN PHÍ</b>
                <i>(ký, ghi rõ họ tên)</i>
              </div>
              <div style={{ height: 70 }} />
              <div>
                <div>Ngày......tháng.....năm.....</div>
                <b>GIÁM ĐỊNH BHYT</b>
                <i>(ký, ghi rõ họ tên)</i>
                <div>&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div >
  );
};

export default BangKeChiPhi;